import './index.sass';
import initNotificationItem from './notification-item';
import axios from "axios";

export default () => {
  initNotificationItem();
  const $btn = $('.js-more-notification');
  const $loader = $('.notification__loader')
  let url = $btn.data('url');

  $('.js-more-notification').on('click', function() {
    let lastPage;
    $(this).addClass('notification__button--hidden');
    $loader.addClass('notification__loader--show');
    axios({
      url: url,
      method: 'GET',
      headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')}
    }).then((response) => {
      if(!lastPage) {
        $('.notification__items').append(response.data.items);
        $(this).attr('data-url', response.data.url);
        url = '/notifications.json?page=12';
        $(this).removeClass('notification__button--hidden');
        $loader.removeClass('notification__loader--show');
        lastPage = response.data.last_page
      }
      if(lastPage) {
        $(this).remove();
      }
    });
  })
};